import React from 'react';
import { Bookmark } from 'lucide-react';

const BookmarksMockup: React.FC = () => {
  return (
    <div className="bg-gray-50 rounded-2xl p-5 h-[380px] flex flex-col shadow-lg">
      {/* Header */}
      <div className="flex justify-between items-center mb-4">
        <h3 className="text-xl font-bold text-gray-800">Bookmarks</h3>
        <div className="flex items-center gap-2">
          <button className="h-8 px-3 rounded-full text-xs font-medium bg-white text-gray-700 border border-gray-300 shadow-sm flex items-center gap-1">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <line x1="12" y1="5" x2="12" y2="19"></line>
              <line x1="5" y1="12" x2="19" y2="12"></line>
            </svg>
            Add Bookmark
          </button>
        </div>
      </div>

      {/* Bookmarks Content */}
      <div className="flex-1 overflow-y-auto pr-2">
        <div className="grid grid-cols-2 gap-4">
          {/* Bookmark Card 1 */}
          <div className="relative group bg-white border rounded-xl shadow-sm overflow-hidden flex flex-col h-auto cursor-pointer">
            {/* Image section */}
            <div className="h-32 bg-gray-100 relative overflow-hidden">
              <img 
                src="https://images.unsplash.com/photo-1586717791821-3f44a563fa4c?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=60" 
                alt="Website preview"
                className="w-full h-full object-cover transition-transform group-hover:scale-105"
              />
            </div>

            {/* Content section */}
            <div className="p-4 flex-1 flex flex-col">
              <h3 className="font-medium text-gray-900 line-clamp-1 mb-1">
                Industry Report 2023
              </h3>
              <p className="text-gray-500 text-xs line-clamp-3 mb-2">
                Comprehensive market analysis and forecasts for the upcoming fiscal year with detailed sector insights.
              </p>
              <div className="mt-auto flex items-center">
                <span className="text-xs text-gray-400 truncate">marketresearch.com</span>
              </div>
            </div>

            {/* Menu button */}
            <div className="absolute top-2 right-2">
              <button className="p-1 bg-white/80 hover:bg-white rounded-full text-gray-600 opacity-0 group-hover:opacity-100 transition-opacity">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="1"></circle>
                  <circle cx="19" cy="12" r="1"></circle>
                  <circle cx="5" cy="12" r="1"></circle>
                </svg>
              </button>
            </div>
          </div>

          {/* Bookmark Card 2 */}
          <div className="relative group bg-white border rounded-xl shadow-sm overflow-hidden flex flex-col h-auto cursor-pointer">
            {/* Image section */}
            <div className="h-32 bg-gray-100 relative overflow-hidden">
              <img 
                src="https://images.unsplash.com/photo-1542744173-8e7e53415bb0?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=60" 
                alt="Website preview"
                className="w-full h-full object-cover transition-transform group-hover:scale-105"
              />
            </div>

            {/* Content section */}
            <div className="p-4 flex-1 flex flex-col">
              <h3 className="font-medium text-gray-900 line-clamp-1 mb-1">
                Competitor Analysis
              </h3>
              <p className="text-gray-500 text-xs line-clamp-3 mb-2">
                Detailed comparison with top 5 competitors in the market with SWOT analysis and strategic recommendations.
              </p>
              <div className="mt-auto flex items-center">
                <span className="text-xs text-gray-400 truncate">internal-docs.company.com</span>
              </div>
            </div>

            {/* Menu button */}
            <div className="absolute top-2 right-2">
              <button className="p-1 bg-white/80 hover:bg-white rounded-full text-gray-600 opacity-0 group-hover:opacity-100 transition-opacity">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="1"></circle>
                  <circle cx="19" cy="12" r="1"></circle>
                  <circle cx="5" cy="12" r="1"></circle>
                </svg>
              </button>
            </div>
          </div>

          {/* Bookmark Card 3 */}
          <div className="relative group bg-white border rounded-xl shadow-sm overflow-hidden flex flex-col h-auto cursor-pointer">
            {/* Image section */}
            <div className="h-32 bg-gray-100 relative overflow-hidden">
              <img 
                src="https://images.unsplash.com/photo-1551288049-bebda4e38f71?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=60" 
                alt="Website preview"
                className="w-full h-full object-cover transition-transform group-hover:scale-105"
              />
            </div>

            {/* Content section */}
            <div className="p-4 flex-1 flex flex-col">
              <h3 className="font-medium text-gray-900 line-clamp-1 mb-1">
                Marketing Strategy Guide
              </h3>
              <p className="text-gray-500 text-xs line-clamp-3 mb-2">
                A comprehensive guide to digital marketing strategies for SaaS products in competitive markets.
              </p>
              <div className="mt-auto flex items-center">
                <span className="text-xs text-gray-400 truncate">marketingstrategy.io</span>
              </div>
            </div>

            {/* Menu button */}
            <div className="absolute top-2 right-2">
              <button className="p-1 bg-white/80 hover:bg-white rounded-full text-gray-600 opacity-0 group-hover:opacity-100 transition-opacity">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="1"></circle>
                  <circle cx="19" cy="12" r="1"></circle>
                  <circle cx="5" cy="12" r="1"></circle>
                </svg>
              </button>
            </div>
          </div>

          {/* Bookmark Card 4 */}
          <div className="relative group bg-white border rounded-xl shadow-sm overflow-hidden flex flex-col h-auto cursor-pointer">
            {/* Image section */}
            <div className="h-32 bg-gray-100 relative overflow-hidden">
              <img 
                src="https://images.unsplash.com/photo-1581291518633-83b4ebd1d83e?ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D&auto=format&fit=crop&w=500&q=60" 
                alt="Website preview"
                className="w-full h-full object-cover transition-transform group-hover:scale-105"
              />
            </div>

            {/* Content section */}
            <div className="p-4 flex-1 flex flex-col">
              <h3 className="font-medium text-gray-900 line-clamp-1 mb-1">
                Design Resources
              </h3>
              <p className="text-gray-500 text-xs line-clamp-3 mb-2">
                Collection of design tools, templates, and inspiration for creating effective product interfaces.
              </p>
              <div className="mt-auto flex items-center">
                <span className="text-xs text-gray-400 truncate">design.resources.com</span>
              </div>
            </div>

            {/* Menu button */}
            <div className="absolute top-2 right-2">
              <button className="p-1 bg-white/80 hover:bg-white rounded-full text-gray-600 opacity-0 group-hover:opacity-100 transition-opacity">
                <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                  <circle cx="12" cy="12" r="1"></circle>
                  <circle cx="19" cy="12" r="1"></circle>
                  <circle cx="5" cy="12" r="1"></circle>
                </svg>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export const bookmarksMockupData = {
  type: 'Bookmarks',
  icon: Bookmark,
  description:
    'Save and organize important links, websites, and resources in one central location. Create categories, add notes, and quickly access everything you\'ve bookmarked across all your projects.',
  mockup: <BookmarksMockup />
};

export default BookmarksMockup;